import { render, staticRenderFns } from "./ym-cost.vue?vue&type=template&id=8d779044&scoped=true&"
import script from "./ym-cost.vue?vue&type=script&lang=js&"
export * from "./ym-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d779044",
  null
  
)

export default component.exports